<template>
    <div id="materials_layout">
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div v-else class="ui active centered inline large loader"></div>
    </div>
</template>

<script>
export default {
    name: "MaterialsLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.$noty.information(
                    this.$t("ui.page_titles.materials") + ' ' +
                    this.$t('ui.general.initialize_complete')
                , 300)
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
    }
}
</script>
